// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallActionsPanelButton__button-da99ed {
  width: 66px;
  height: 40px;
  border-radius: 100px !important;
  min-width: 66px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.CallActionsPanelButton__icon-e4ff55 {
  fill: currentColor;
  padding: 2px;
  border-radius: 50%;
}

.CallActionsPanelButton__main-icon-dc3a17 {
  margin-inline-start: 12px;
}

.CallActionsPanelButton__disabled-icon-ea936e {
  opacity: 0.5;
}

.CallActionsPanelButton__hidden-icon-c2a45c {
  visibility: hidden;
}

.CallActionsPanelButton__arrowButtonContainer-b6c702 {
  width: fit-content;
  height: fit-content;
  border-radius: 50%;
  margin-inline-start: 2px;
  color: currentColor;
  margin-inline-end: 8px;
}

.CallActionsPanelButton__arrow-button-f9503c {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: currentColor;
  fill: var(--addition-50_20);
}

.CallActionsPanelButton__arrow-button-f9503c:hover {
  background: var(--addition-50_20);
  cursor: pointer;
}

.CallActionsPanelButton__pressed-cbfdcd {
  background: var(--addition-50_30);
}

.CallActionsPanelButton__pressed-cbfdcd:hover {
  background: var(--addition-50_30);
}

.CallActionsPanelButton__is-active-cb61c7:hover {
  background: var(--addition-40_05);
  cursor: pointer;
}

.CallActionsPanelButton__pressed-active-c64901 {
  background: var(--addition-40_10);
}

.CallActionsPanelButton__pressed-active-c64901:hover {
  background: var(--addition-40_10);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/CallActionsPanelButton/CallActionsPanelButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AAEA;EACE,iCAAA;EACA,eAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,iCAAA;EACA,eAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,iCAAA;AACF","sourcesContent":[".button {\n  width: 66px;\n  height: 40px;\n  border-radius: 100px !important;\n  min-width: 66px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0;\n}\n\n.icon {\n  fill: currentColor;\n  padding: 2px;\n  border-radius: 50%;\n}\n\n.main-icon {\n  margin-inline-start: 12px;\n}\n\n.disabled-icon {\n  opacity: 0.5;\n}\n\n.hidden-icon {\n  visibility: hidden;\n}\n\n.arrowButtonContainer {\n  width: fit-content;\n  height: fit-content;\n  border-radius: 50%;\n  margin-inline-start: 2px;\n  color: currentColor;\n  margin-inline-end: 8px;\n}\n\n.arrow-button {\n  display: block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: currentColor;\n  fill: var(--addition-50_20);\n}\n\n.arrow-button:hover {\n  background: var(--addition-50_20);\n  cursor: pointer;\n}\n\n.pressed {\n  background: var(--addition-50_30);\n}\n\n.pressed:hover {\n  background: var(--addition-50_30);\n}\n\n.is-active:hover {\n  background: var(--addition-40_05);\n  cursor: pointer;\n}\n\n.pressed-active {\n  background: var(--addition-40_10);\n}\n\n.pressed-active:hover {\n  background: var(--addition-40_10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `CallActionsPanelButton__button-da99ed`,
	"icon": `CallActionsPanelButton__icon-e4ff55`,
	"main-icon": `CallActionsPanelButton__main-icon-dc3a17`,
	"mainIcon": `CallActionsPanelButton__main-icon-dc3a17`,
	"disabled-icon": `CallActionsPanelButton__disabled-icon-ea936e`,
	"disabledIcon": `CallActionsPanelButton__disabled-icon-ea936e`,
	"hidden-icon": `CallActionsPanelButton__hidden-icon-c2a45c`,
	"hiddenIcon": `CallActionsPanelButton__hidden-icon-c2a45c`,
	"arrowButtonContainer": `CallActionsPanelButton__arrowButtonContainer-b6c702`,
	"arrow-button": `CallActionsPanelButton__arrow-button-f9503c`,
	"arrowButton": `CallActionsPanelButton__arrow-button-f9503c`,
	"pressed": `CallActionsPanelButton__pressed-cbfdcd`,
	"is-active": `CallActionsPanelButton__is-active-cb61c7`,
	"isActive": `CallActionsPanelButton__is-active-cb61c7`,
	"pressed-active": `CallActionsPanelButton__pressed-active-c64901`,
	"pressedActive": `CallActionsPanelButton__pressed-active-c64901`
};
module.exports = ___CSS_LOADER_EXPORT___;
